/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const OpenRecentOutlineIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Open Recent Outline',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M16.051 28H4l4.689-14h24.536l-1.093 3.279a10.983 10.983 0 0 1 1.729 1.138l1.7-5.1A1 1 0 0 0 34.613 12H32V9a1 1 0 0 0-1-1l-12.332.007-3.3-3.4A2 2 0 0 0 13.929 4H4a2 2 0 0 0-2 2v23a1 1 0 0 0 1 1h13.427a10.837 10.837 0 0 1-.376-2Z"
    />
    <path
      d="M27 18.1a8.9 8.9 0 1 0 8.9 8.9 8.9 8.9 0 0 0-8.9-8.9Zm0 16a7.1 7.1 0 0 1-1-14.121V27a1 1 0 0 0 .293.707l3.023 3.023a.5.5 0 0 0 .707 0l.707-.708a.5.5 0 0 0 0-.707L28 26.586v-6.608A7.1 7.1 0 0 1 27 34.1Z"
    />
  </svg>`;
};
